// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"53572914","455":"925899d8"}[chunkId] + ".chunk.js";
};